import { useIsMobileBreakpoint } from "../../../../hooks/useIsMobileBreakpoint";
import ActionButton from "./actionButton";
import PhaseButton from "./phaseButton";
import "./actions.sass";

const PHASE_CONFIG = {
  qualifying: {
    className: "simulatorQualifying",
    simulateText: "SIMULAR ELIMINATORIAS",
  },
  groups: {
    className: "simulatorGroups",
    simulateText: "SIMULAR TODO",
  },
};

export default function Actions({ handlePhaseChange, phase, onSimulate, onSimulateQualifying, onReset, isGroupsComplete }) {
  const isMobile = useIsMobileBreakpoint(768);

  const handleQualifyingClick = () => {
    if (isGroupsComplete) {
      handlePhaseChange("qualifying");
    }
  };

  const { className: phaseClass, simulateText: textSimulate } = PHASE_CONFIG[phase] ?? PHASE_CONFIG["groups"];
  const handleSimulateClick = phase === "qualifying" ? onSimulateQualifying : onSimulate;


  const actionButtons = (
    <>
      {phase !== "qualifying" && <ActionButton onClick={handleSimulateClick} variant="simulate">{textSimulate}</ActionButton>}
      <ActionButton onClick={onReset} variant="reset">REINICIAR</ActionButton>
    </>
  );

  const phaseButtons = (
    <>
      <PhaseButton isActive={phase === "groups"} onClick={() => handlePhaseChange("groups")}>
        FASE DE GRUPOS
      </PhaseButton>
      <PhaseButton isActive={phase === "qualifying"} isDisabled={!isGroupsComplete} onClick={handleQualifyingClick}>
        ELIMINATORIAS
      </PhaseButton>
    </>
  );

  if (isMobile) {
    return (
      <div className={`SimulatorTopBar SimulatorTopBar--mobile ${phaseClass}`}>
        <div className="SimulatorTopBar__row topBar">
          {actionButtons}
        </div>
        <div className="SimulatorTopBar__row bottomBar">
          {phaseButtons}
        </div>
      </div>
    );
  }

  return (
    <div className={`SimulatorTopBar ${phaseClass}`}>
      <div className={`SimulatorTopBar__left ${phaseClass}`}>
        {phase !== "qualifying" && <ActionButton onClick={handleSimulateClick} variant="simulate">{textSimulate}</ActionButton>}
      </div>

      <div className="SimulatorTopBar__center">
        {phaseButtons}
      </div>

      <div className={`SimulatorTopBar__right ${phaseClass}`}>
        <ActionButton onClick={onReset} variant="reset">REINICIAR</ActionButton>
      </div>
    </div>
  );
}